import "@hotwired/turbo-rails"

// jQuery должен быть импортирован первым для Cocoon
import jquery from 'jquery'
window.$ = window.jQuery = jquery

// Moment.js
import moment from 'moment'
import 'moment/locale/ru'
window.moment = moment
moment.locale('ru')

// Select2
import select2 from 'select2';
select2($);

// Daterangepicker
import 'daterangepicker'

// Bootstrap Datepicker
import 'bootstrap-datepicker'

// Chart.js
import {
  Chart,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  LineController
} from 'chart.js'

Chart.register(
    LineController,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
)

window.Chart = Chart


/**
 * Russian translation for bootstrap-datepicker
 * Victor Taranenko <darwin@snowdale.com>
 */
;(function($){
	$.fn.datepicker.dates['ru'] = {
		days: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
		daysShort: ["Вск", "Пнд", "Втр", "Срд", "Чтв", "Птн", "Суб"],
		daysMin: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
		months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
		monthsShort: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
		today: "Сегодня",
		clear: "Очистить",
		format: "dd.mm.yyyy",
		weekStart: 1,
    monthsTitle: 'Месяцы'
	};
}(jQuery));


import './controllers/select2_i18n'

import "./controllers"

// Подключаем специфичные для страниц скрипты
import "./reports"

// Bootstrap
import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap

// Admin theme
import './admin/simplebar.min.js'
import feather from './admin/feather.min.js'
window.feather = feather
import './admin/pcoded.js'

// Cocoon для nested forms (после jQuery)
import "cocoon-js-vanilla";



import "trix"
import "@rails/actiontext"


//// app/javascript/tinymce_turbo_fix.js
document.addEventListener("turbo:before-render", () => {
    if (window.tinymce) tinymce.remove();   // разрушить ВСЕ текущие инстанции
    console.log("tinymce instances removed before render");
});

document.addEventListener("turbo:before-cache", () => {
    if (window.tinymce) tinymce.remove();   // по-прежнему очищаем перед кэшированием
    console.log("tinymce instances removed before cache");
});

const tinyMCSInit = function () {
    if (window.tinymce && document.querySelector("textarea.tinymce")) {
        console.log("Reinitializing TinyMCE on turbo:load");
        tinymce.init({
            selector: "textarea.tinymce",
            language: "ru",
            menubar: false,
            toolbar: "undo redo | styles | bold italic underline | forecolor backcolor | alignleft aligncenter alignright | image blockquote",
            plugins: ['image', 'autolink'],
            automatic_uploads: true,
            images_upload_url: "/tinymce_images",
            // images_reuse_filename: true,
            images_upload_credentials: true,
            license_key: 'gpl',
            relative_urls: false,
            remove_script_host: true
        });
    }
}

// повторная инициализация после навигации
document.addEventListener("turbo:render", () => {
    console.log("turbo:render event fired");
    tinyMCSInit();
});

document.addEventListener("turbo:load", () => {
    console.log("turbo:render event fired");
    tinyMCSInit();
});